import Vue from 'vue'

export async function getFavorites ({ commit }) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })
    const { data } = await Vue.axios({
      url: '/favorite'
    })
    commit('setFavorites', data)
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

export async function createFavorite ({ commit }, productID) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })
    const { data } = await Vue.axios({
      method: 'POST',
      url: '/favorite',
      data: {
        IdProducto: productID
      }
    })
    return data
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

export async function removeFavorite ({ commit, dispatch }, id) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })
    await Vue.axios({
      method: 'DELETE',
      url: `/favorite/${id}`
    })
    dispatch('getFavorites')
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}
